<template>
  <div class="bb-modal" @click.stop @keyup.esc="close()">
    <div
      :class="[
        'bb-modal-wrapper',
        customWrapperClass,
        tableMode && 'bb-modal-wrapper_table',
        withoutPadding && 'bb-modal-wrapper_without-padding',
      ]"
      @click.stop
    >
      <i
        class="icon-cross bb-modal-wrapper__close"
        :class="{
          'bb-modal-wrapper__close_big': isCloseBig,
        }"
        @click.stop="close"
      />
      <div
        v-if="title"
        class="bb-modal-wrapper__title"
        :class="[
          centerTitle && 'bb-modal-wrapper__title_center',
          withoutPaddingTitle && 'bb-modal-wrapper__title_without-padding'
        ]"
      >
        {{title}}
      </div>
      <vue-perfect-scrollbar
        class="bb-modal-child"
        ref="modalBody"
        :class="{
          'bb-modal-child_without-padding': withoutPadding,
          'bb-modal-child_without-padding-child': withoutPaddingChild,
          'bb-modal-child_table': tableMode
        }">
        <slot></slot>
      </vue-perfect-scrollbar>
      <slot name="buttons"></slot>
      <div class="bb-modal-wrapper__empty" v-if="tableMode"/>
      <div
        v-if="isFooter"
        :class="[
            'bb-modal-footer',
            isBigRightButton && 'bb-modal-footer_big-button',
            isFooterMargin && 'bb-modal-footer_margin'
          ]"
      >
        <button
          class="bb-button bb-button_gray"
          @click="close"
        >
          CANCEL
        </button>
        <button
          :class="[
            'bb-button',
            isBigRightButton && 'bb-modal-footer__button_big'
          ]"
          @click="handlerClick"
        >
          {{buttonRightName}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import scrollTo from '@/mixin/scrollTo'

export default {
  name: 'ModalWindow',
  props: [
    'tableMode',
    'title',
    'withoutPadding',
    'centerTitle',
    'scrollToError',
    'customWrapperClass',
    'isCloseBig',
    'isFooter',
    'buttonRightName',
    'isBigRightButton',
    'withoutPaddingTitle',
    'isFooterMargin',
    'withoutPaddingChild'
  ],
  mixins: [scrollTo],
  components: {
    VuePerfectScrollbar
  },
  methods: {
    close () {
      this.$emit('close')
    },
    handlerClick () {
      this.$emit('handlerClick')
    }
  },
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    })
  },
  watch: {
    scrollToError (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const modal = this.$refs.modalBody.$el
          const { scrollTop } = modal
          const { top: modalTop } = modal.getBoundingClientRect()
          const [errorFiled] = document.getElementsByClassName('bb-input_error')
          const { top } = errorFiled.getBoundingClientRect()
          const newScrollTop = (top - modalTop) + scrollTop
          this.scrollTo(modal, newScrollTop, 100, 'clear')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-modal {
    @include global-font;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba($color-black, 0.56);
    padding: 30px;

    &-wrapper {
      display: flex;
      flex-direction: column;
      max-height: 90vh;
      padding: 30px;
      position: relative;
      background-color: $color-white;
      border-radius: 8px;

      &__empty {
        height: 10px;
        background-color: $color-white;
        border-radius: 0 0 8px 8px;
      }

      &__small-padding {
        padding: 18px;

        .bb-modal-wrapper__close {
          top: 10px;
          right: 10px;
        }
      }

      &__title {
        margin: 21px 40px 20px;
        text-align: center;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 21px;

        &_center {
          position: relative;
          bottom: 10px;
          font-weight: 500;
          font-size: 17px;
          line-height: 20px;
        }

        &_without-padding {
          margin: 0;
          bottom: 2px;
        }
      }

      &_table {
        padding: 0;

        .bb-modal-child {
          margin-right: 0;
          padding-right: 0;
        }
      }

      &_without-padding {
        padding: 0
      }

      &_min-padding {
        padding: 15px 18px 15px 18px;
      }

      &_padding {
        padding: 40px 20px 20px 20px;

        .bb-modal-child {
          margin-right: -20px;
          padding-right: 20px;
        }
      }

      &__close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        position: absolute;
        top: 6px;
        right: 6px;
        font-size: 18px;
        cursor: pointer;
        color: $color-silver;
        z-index: 100;
        transition: 0.3s;

        &:hover {
          color: $color-silver-chalice;
        }

        &_big {
          font-size: 20px;
          top: 9px;
          right: 10px;
        }
      }
    }

    &-child {
      max-height: 75vh;
      max-width: 99vw;
      margin-right: -38px;
      padding-right: 38px;
      overflow: hidden;

      &_without-padding {
        max-height: 90vh;
        margin-right: -8px;
        padding-right: 8px;
      }

      &_without-padding-child {
        max-height: 90vh;
        margin-right: 0;
        padding-right: 0;
      }

      &_table {
        padding-bottom: 10px;
        margin-bottom: -10px;
      }
    }

    &_for-close {
      width: 0;
      height: 0;
      opacity: 0;
      position: fixed;
      top: 0;
      left: 0;
    }

    .bb-modal-footer {
      display: grid;
      grid-template-columns: repeat(2, 103px);
      grid-gap: 0 12px;
      justify-content: end;
      height: 80px;
      border-top: 1px solid $color-mercury;
      margin: 0 -18px -15px -18px;
      padding: 18px;
      background: $color-alabaster;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;

      &_big-button {
        grid-template-columns: 103px 164px;
      }

      &_margin {
        margin: 0 -18px -18px -18px;

        .bb-button {
          height: 46px;
        }
      }

      &__button {

        &_big {
          font-size: 17px;
        }
      }
    }
  }

</style>

<style lang="scss">
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-modal {
    .ps__thumb-y,
    .ps__thumb-y {
      width: 4px;
      z-index: 3;
    }

    .ps__rail-x {
      display: none;
    }

    .ps__thumb-x {
      opacity: 0;
    }

    .ps__rail-y.ps--clicking .ps__thumb-y,
    .ps__rail-y:focus > .ps__thumb-y,
    .ps__rail-y:hover > .ps__thumb-y {
      width: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/ModalWindow/ModalWindow.vue